import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M4 11.725c0-.4.325-.725.725-.725.42 0 .751-.355.723-.773l-.277-4.159a2 2 0 0 1 2.36-2.1l9.493 1.759a2 2 0 0 1 1.625 1.767l.304 3.033a.525.525 0 0 0 .522.473c.29 0 .525.235.525.525V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.46 4.4H7.286a1.6 1.6 0 0 0-1.6 1.6v4.583h-1.4V6a3 3 0 0 1 3-3H8.46a3 3 0 0 1 1.754.566l.143.103a3 3 0 0 0 1.755.567h4.602a3 3 0 0 1 3 3v3.347h-1.4V7.236a1.6 1.6 0 0 0-1.6-1.6h-4.602a4.4 4.4 0 0 1-2.573-.831l-.143-.103A1.6 1.6 0 0 0 8.46 4.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.46 7.246H7.286a1.6 1.6 0 0 0-1.6 1.6V11h-1.4V8.846a3 3 0 0 1 3-3H8.46a3 3 0 0 1 1.754.566l.143.103a3 3 0 0 0 1.754.567h4.603a3 3 0 0 1 3 3V11h-1.4v-.918a1.6 1.6 0 0 0-1.6-1.6h-4.603a4.4 4.4 0 0 1-2.573-.83l-.142-.104a1.6 1.6 0 0 0-.936-.302"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 11.228H6a1.6 1.6 0 0 0-1.6 1.6V18A1.6 1.6 0 0 0 6 19.6h12a1.6 1.6 0 0 0 1.6-1.6v-5.172a1.6 1.6 0 0 0-1.6-1.6m-12-1.4a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.172a3 3 0 0 0-3-3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.429 13.714c0-.473.383-.857.857-.857h3.428a.857.857 0 0 1 0 1.714h-3.428a.857.857 0 0 1-.857-.857"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=PortfolioIcon24.js.map